import React from 'react'
import { Link } from "react-router-dom"
import { Typography, Card, CardContent, CardMedia } from "@mui/material"
import { CheckCircle } from "@mui/icons-material"

import { demoThumbnailUrl, demoVideoUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle } from "../utils/constants"

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  var value = txt.value;
  txt.remove();
  return value;
}

const VideoCard = ({ video: {id: { videoId }, snippet } }) => {
  if (snippet) {
    snippet.title = decodeHtml(snippet.title) 
  }
  return (
    <Card sx={{ width: { xs: '100%', sm: '358px', md: '320px' }, boxShadow: 'none', borderRadius: 0 }}>
      <Link to={videoId ? `/video/${videoId}` : demoVideoUrl }>
        <CardMedia 
          image={snippet?.thumbnails?.high?.url}
          alt={snippet?.title}
          sx={{width: {
              xs:'100%', sm: '358px', md: '320px'
          }, height: 180 }}
        />
        <CardContent sx={{ backgroundColor: '#1e1e1e', height: '106px'}}>
          <Link to={videoId ? `/video/${videoId}` : demoVideoUrl }>
            <Typography variant="subtitle1" fontWeight="bold" color="#FFF">
              {snippet?.title.slice(0, 60)}
            </Typography>
          </Link>
          <Link to={snippet?.channelId ? `/channel/${snippet?.channelId}` : demoVideoUrl }>
            <Typography variant="subtitle2" fontWeight="bold" color="gray">
              {snippet?.channelTitle || demoChannelTitle }
              <CheckCircle sx={{ fontSize: 12, color: 'gray', ml: '5px'}}/>
            </Typography>
          </Link>
        </CardContent>
      </Link>

    </Card>
  )
}

export default VideoCard
